const applyButton = document.querySelector('.to-apply');
const vacanciesClose = document.querySelector('.vacancies-close');
const vacanciesModal = document.querySelector('.form-vacancies');
const vacanciesContainer = document.querySelector('.main-vacancies');

if (vacanciesModal) {

    applyButton?.addEventListener('click', () => {
        vacanciesModal.classList.add('opened');
        Piki.lockScroll()
    });

    vacanciesClose?.addEventListener('click', () => {
        vacanciesModal.classList.remove('opened');
        Piki.unlockScroll()
    });

    document.addEventListener('click', (event) => {

        const clickedInsideContainer = vacanciesContainer?.contains(event.target);
        const clickedApplyButton = applyButton?.contains(event.target);

        if ( vacanciesModal.classList.contains('opened') && !clickedInsideContainer && !clickedApplyButton ) {
            vacanciesModal.classList.remove('opened');
        }

    });

}